module.exports = __webpack_public_path__ + "static/media/maintenance.4c146d22.png";